import React, { useEffect, useState } from 'react'
import Img from "gatsby-image"

const ImageZoom = ({ image, ...props }) => {
  const [InnerImageZoom, setInnerImageZoom] = useState(null)

  const sources = [
    {
      srcSetWebp: image.fluid.srcSet,
      type: "image/webp"
    },
    {
      srcSet: image.fluid.srcSet,
      type: "image/jpeg"
    }
  ]

  useEffect(() => {
    if (!InnerImageZoom) {
      const loadImageZoom = async () => {
        // ? Docs: https://github.com/laurenashpole/react-inner-image-zoom
        await import("./../react-inner-image-zoom/InnerImageZoom/styles.min.css")
        const innerImageZoomLibrary = await import("./../react-inner-image-zoom")
        const innerImageZoomComponent = React.createElement(innerImageZoomLibrary.default, {
          src: image.fluid.src,
          srcSet: image.fluid.srcSet,
          sources: [sources],
          zoomScale: 1.2,
          fullscreenOnMobile: true,
          mobileBreakpoint: 959,
          zoomType: "hover", // ? "hover" or "click,
          moveType: "pan", // ? "pan" or "drag,
          zoomSrc: image.fluid.src.replace(/w=(\d*)/, "w=800").replace(/q=(\d*)/, "q=100"),
          alt: 'Showcases product',
          ...props
        })
        setInnerImageZoom(innerImageZoomComponent)
      }
      loadImageZoom()
    }
  })

  // * SSR
  if (!InnerImageZoom) {
    return <Img
      fluid={image.fluid}
      alt='Showcases product'
      {...props}
    />
  }

  return (<>{InnerImageZoom}</>)
}

export default ImageZoom

/* <InnerImageZoom
  src={image.src}
  srcSet={image.srcSet}
  sizes={image.sizes}
  zoomScale={1.2}
  zoomType="hover" // ? "hover" or "click"
  moveType="pan" // ? "pan" or "drag"
  zoomSrc={image.src.replace(/w=(\d*)/, "w=800").replace(/q=(\d*)/, "q=100")}
  {...props}
/> */